// extracted by mini-css-extract-plugin
export default {"DataSecurity":"Credit_DataSecurity__duVqu","Background":"Credit_Background__V-q3x"};